import { PartialProduct } from "@shared/types";
import { ITEM_BRAND } from "config";
import { logProductDetailViewEvent } from "helpers/analyticsLogger";
import { useEffect } from "react";
import { ProductBySlugQuery } from "services/datocms/generated";
import {
  DynamicBundlesQuery,
  ItemByGtinQuery,
} from "services/graphql/generated";

export const useProductMachineAnalytics = (
  currency: string | undefined,
  datoProduct: ProductBySlugQuery["product"] | null,
  pepDirectProduct: ItemByGtinQuery["itemByGtin"] | null,
  allDynamicBundles?: DynamicBundlesQuery | undefined,
) => {
  useEffect(() => {
    if (pepDirectProduct && datoProduct && currency && allDynamicBundles) {
      const pepdirectProductBundles = datoProduct.productBundles.map(
        (datoBundle) => {
          const pepBundle = allDynamicBundles.dynamicBundles?.find(
            (pepBundle) => pepBundle?.tag === datoBundle.bundleId,
          );
          return pepBundle;
        },
      );

      let totalValue = 0;

      const items: PartialProduct[] = [];

      pepdirectProductBundles?.forEach((bundle, index) => {
        const price = bundle?.discountPrice ? bundle?.discountPrice / 100 : 0;
        totalValue += price;
        items.push({
          itemId: bundle?.id,
          gtin: bundle?.primaryComponent.items?.[0]?.gtin,
          itemName: bundle?.name,
          itemBrand: ITEM_BRAND,
          itemCategory: datoProduct.category?.analyticsCategoryName,
          price: price,
          itemListName: undefined,
          currency,
          quantity: 1,
          index: index + 1,
        });
      });

      logProductDetailViewEvent(currency, items, totalValue);
    }
  }, [pepDirectProduct, datoProduct, currency, allDynamicBundles]);
};
